import { Skeleton, Stack } from '@mantine/core';

import type { CardSkeletonRow, CardSkeletonViewProps } from './CardSkeleton.types';

export const DEFAULT_CARD_SKELETON_ROWS: CardSkeletonRow[] = [
  { height: 16, width: '50%' },
  { height: 12, width: '30%' },
  { height: 80, width: '100%' },
];

export function CardSkeletonView({
  rows = DEFAULT_CARD_SKELETON_ROWS,
  avatar = false,
  avatarSize = 48,
  gap = 'sm',
}: CardSkeletonViewProps) {
  return (
    <Stack gap={gap}>
      {avatar && <Skeleton height={avatarSize} circle />}
      {rows.map((row, i) => (
        <Skeleton key={i} height={row.height ?? 12} width={row.width ?? '100%'} />
      ))}
    </Stack>
  );
}
